import { render, staticRenderFns } from "./Wiki-image.vue?vue&type=template&id=afd7b4f2&scoped=true&"
import script from "./Wiki-image.vue?vue&type=script&lang=js&"
export * from "./Wiki-image.vue?vue&type=script&lang=js&"
import style0 from "./Wiki-image.vue?vue&type=style&index=0&id=afd7b4f2&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "afd7b4f2",
  null
  
)

export default component.exports